import * as React from 'react';

import { MosaicViewManager } from 'src/components/mosaic/MosaicViewManager';
import { MosaicCollapseOptionsById } from 'src/components/mosaic/types';
import {
  MosaicSplitOptions,
  MosaicSplitType,
  NestedMosaicParentInitial,
  ProjectTileId,
} from 'src/constants/mosaic';
import { ProjectSidebar } from 'src/containers/Project/ProjectSidebar';
import { ProjectWorkspace } from 'src/containers/Project/ProjectWorkspace';

const collapseOptions: MosaicCollapseOptionsById<ProjectTileId> = {
  [ProjectTileId.SIDEBAR]: {
    collapsible: true,
    collapsed: false,
    collapsedSize: 15,
    collapsedVisible: false,
  },
};

const initialValue: NestedMosaicParentInitial<ProjectTileId> = {
  direction: 'row',
  first: ProjectTileId.SIDEBAR,
  second: ProjectTileId.VIEW,
};

const splitOptions: MosaicSplitOptions = {
  firstMinSplitType: MosaicSplitType.NUMBER,
  firstMinSplitValue: 200,
  secondMinSplitType: MosaicSplitType.PERCENT,
  secondMinSplitValue: 25,
  initialSplitPercentage: 20,
};

export const ProjectView = () => {
  return (
    <MosaicViewManager
      collapseOptions={collapseOptions}
      containerClassName="sd-project sd-container"
      initialValue={initialValue}
      splitOptions={splitOptions}
    >
      <ProjectSidebar id={ProjectTileId.SIDEBAR} />
      <ProjectWorkspace id={ProjectTileId.VIEW} />
    </MosaicViewManager>
  );
};
